import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ChevronRight, Shapes } from "lucide-react";
import { SIGNS, SignMini } from "@/components/map/SignObjects";

export const ObjectsMenu = ({ mode, setMode }) => {
  const [open, setOpen] = useState(null);  // posición del menú en pantalla (null = cerrado)
  const ref = useRef(null);
  const menu = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => !ref.current?.contains(e.target) && !menu.current?.contains(e.target) && setOpen(null);
    const esc = (e) => e.key === "Escape" && setOpen(null);
    const scroll = () => setOpen(null);  // el menú está fijo en pantalla: si la página se mueve, se cierra
    document.addEventListener("mousedown", away);
    window.addEventListener("keydown", esc);
    window.addEventListener("scroll", scroll);
    return () => { document.removeEventListener("mousedown", away); window.removeEventListener("keydown", esc); window.removeEventListener("scroll", scroll); };
  }, [open]);
  const cur = mode?.startsWith("sign:") ? mode.slice(5) : null;
  const on = cur || mode === "sign_line";
  const pick = (m) => { setMode(mode === m ? null : m); setOpen(null); };
  // el menú va fuera de la barra (que puede desplazarse en pantallas bajas) y sin salirse de la pantalla
  const abrir = () => {
    if (open) return setOpen(null);
    const r = ref.current.getBoundingClientRect();
    return setOpen({ left: Math.min(r.right + 8, window.innerWidth - 264), top: Math.max(8, Math.min(r.top, window.innerHeight - 420)) });
  };
  return (
    <div className="relative" ref={ref}>
      <button onClick={abrir} data-testid="map-objects-menu-button" title="Objetos de señalización"
        className={`w-[3.6rem] flex flex-col items-center gap-0.5 px-1 py-1.5 rounded-lg text-[0.5625rem] leading-tight font-medium transition-colors ${on || open ? "bg-amber-400 text-slate-950" : "text-slate-700 hover:bg-slate-100"}`}>
        {cur ? <SignMini type={cur} size={18} /> : <Shapes className="w-[1.125rem] h-[1.125rem] text-amber-600" />}
        <span className="flex items-center">Objetos<ChevronRight className="w-2.5 h-2.5" /></span>
      </button>
      {open && createPortal(
        <div ref={menu} style={{ left: open.left, top: open.top }} className="fixed z-[1300] w-64 max-h-[calc(100dvh-1rem)] overflow-y-auto bg-white/95 backdrop-blur-md border border-slate-200 rounded-xl p-1 shadow-2xl rise" data-testid="map-objects-toolbar">
          {Object.entries(SIGNS).map(([k, v]) => (
            <button key={k} data-testid={`map-add-sign-${k}`} onClick={() => pick(v.line ? "sign_line" : `sign:${k}`)}
              className={`w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg text-xs transition-colors ${cur === k || (v.line && mode === "sign_line") ? "bg-amber-400 text-slate-950" : "text-slate-800 hover:bg-slate-100"}`}>
              <SignMini type={k} size={18} /><span className="flex-1 text-left">{v.label}</span><span className="font-mono text-[0.5625rem] opacity-60">{v.code}</span>
            </button>
          ))}
        </div>, document.body,
      )}
    </div>
  );
};
